
import { Vue, Prop, Component } from "vue-property-decorator";

@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    ProfileMenu: () => import("@/components/Jobs/Profile/ProfileMenu.vue"),
    OfferCard: () => import("@/components/Jobs/Common/OfferCard.vue"),
    LastNews: () => import("@/components/Jobs/Profile/LastNews.vue"),
    Postulate: () => import("@/components/postulation/Postulate.vue")
  }
})
export default class JobsOffersSaved extends Vue {
  offers = [];
  lastNews = [];

  async mounted() {
    if ((this as any).$store.state.token) {
      const response = await (this as any).$root._post(
        "useroffer/filtered_list",
        {
          favorite: 1
        }
      );
      let offers: any = [];
      for (let i: number = 0; i < response.data.length; i++) {
        offers.push({
          ...response.data[i].offer,
          hover: false,
          network: false,
          favorite: response.data[i].favorite,
          postulate: response.data[i].postulate
        });
      }
      (this as any).offers = offers;
    }
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  openModal(offer: any) {
    let postulateComponent = (this as any).$children.find((children: any) => {
      return children.$options._componentTag === "Postulate";
    });
    postulateComponent.offerId = offer.id;
    postulateComponent.showModal();
  }
}
